import { z } from "zod";

import {
  companyOnboardingResponseSchema,
  companyStatusSchema,
  companyTypeSchema,
} from "./company.js";

export const companyModerationDecisionTypes = [
  "verify",
  "reject",
  "block",
  "archive",
] as const;

export const companyModerationDecisionSchema = z.enum(companyModerationDecisionTypes);
export const companyModerationReasonSchema = z.string().trim().min(3).max(2_000);

export const companyModerationDecisionRequestSchema = z.discriminatedUnion("decision", [
  z.object({ decision: z.literal("verify") }),
  z.object({
    decision: z.literal("reject"),
    reason: companyModerationReasonSchema,
  }),
  z.object({
    decision: z.literal("block"),
    reason: companyModerationReasonSchema,
  }),
  z.object({
    decision: z.literal("archive"),
    reason: companyModerationReasonSchema.optional(),
  }),
]);

export const companyModerationListQuerySchema = z.object({
  status: companyStatusSchema.default("pending_review"),
  type: companyTypeSchema.optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});

export const companyModerationListResponseSchema = z.object({
  items: z.array(companyOnboardingResponseSchema),
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  offset: z.number().int().nonnegative(),
});

export type CompanyModerationDecision = z.infer<
  typeof companyModerationDecisionSchema
>;
export type CompanyModerationDecisionRequest = z.infer<
  typeof companyModerationDecisionRequestSchema
>;
export type CompanyModerationListQuery = z.infer<
  typeof companyModerationListQuerySchema
>;
export type CompanyModerationListResponse = z.infer<
  typeof companyModerationListResponseSchema
>;
